import { render } from "./StatusTable.vue?vue&type=template&id=48470429"
import script from "./StatusTable.vue?vue&type=script&lang=js"
export * from "./StatusTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__